import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { LinkListBlock, PlainContentModuleContainer } from "@silvertours/front-entities";
export var SequentialLinkLists = function(param) {
    var lists = param.lists, translations = param.translations;
    /*#__PURE__*/ return _jsx(PlainContentModuleContainer, {
        children: lists.map(function(list) {
            var ref;
            if (list.links.length === 0) {
                return null;
            }
            return /*#__PURE__*/ _jsx(LinkListBlock, {
                content: list,
                translations: translations
            }, ((ref = list.heading) === null || ref === void 0 ? void 0 : ref.text) || list.links[0].label);
        })
    });
};
